import React from "react";
import $ from 'jquery';
import "react-table-6/react-table.css";
import { ToastContainer, toast } from "react-toastify";
import Select from 'react-select';
class AksharTransliteration extends React.Component {
  constructor() {
    super();
    this.state = {
      convertedText: "",
      languageOptions: [],
      selectedLanguageOption: null,
      languageId: null,
      infoTypeList: [],
      langList: [],
      infoTypeDispValue: {},
      langDispValue: {},
      apikeySecret: {}
    }
  };
  handleLangChange = (e) => {

    this.state.langDispValue = e;
    this.setState(this.state)

  }

  handleInfoTypeChange = (e) => {
    this.state.infoTypeDispValue = e;
    this.setState(this.state)
  }
  notifyFailedToLoadLanguages(result) {
    toast.dismiss();
    toast(<b>{result}</b>, {
      position: "top-center",

    });
  }
  notifyNoIndicLangSelected() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;Oops!you have not selected Indic language for your project</b>, {
      position: "top-center"
    });
  }
  notifyNoInput() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;Oops!you have not given any input</b>, {
      position: "top-center"
    });
  }
  fetchAksharTransliterationDataApi = () => {
    var thisController = this;
    var apis = [];
    $.ajax({
      url: "/api/api-key/api-type",
      async: false,
      method: 'GET',
      data: {
        projectId: localStorage.getItem("currentProjectId"),
        apiType: "AKSHAR_API"
      },
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },

      success: function (res) {
        if (res.success === true) {
          var apiData = res.result;
          for (var i = 0; i < apiData.length; i++) {
            if (apiData[i].apiType == "AKSHAR_API") {
              apis.push(apiData[i]);
            }
            thisController.state.apikeySecret = { "value": res.result[0]["key"], "label": res.result[0]["secret"] }
            thisController.state.firstApiKey = res.result[0]["key"].value;
            thisController.state.firstApiSucess = res.result[0]["secret"].label

            if (apiData.length == 0) {
              thisController.setState({
                isChecked: false,
                showTable: false
              })

            }

            else if (apiData[0]["id"] != "" ||
              apiData[0]["id"] != null) {

              thisController.setState({
                isChecked: true,
                showTable: true
              })
            }
          }
          thisController.setState({
            data: apiData,
            disabled: false
          })
        }
        else {
          thisController.NotifyFailToLoadData(res.result)
        }
      },
      error: function (xhr, status, error) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }
  fetchInformationTypeApi() {
    var username = this.state.apikeySecret.value;
    var password = this.state.apikeySecret.label;
    var thisComponent = this;
    $.ajax(
      {
        url: "/api/information-type",
        async: false,
        method: 'GET',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token")
        },
        success: function (res) {
          thisComponent.state.showLoader = false;
          if (res.success === true) {
            for (var i = 0; i < res.result.length; i++) {

              thisComponent.state.infoTypeList.push({ "value": res.result[i]["description"], "label": res.result[i]["name"] });
            }
            thisComponent.state.infoTypeDispValue = { "value": res.result[0]["description"], "label": res.result[0]["name"] };
            thisComponent.setState(thisComponent.state);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    );
  }

  fetchLanguageApi() {
    var username = this.state.apikeySecret.value;
    var password = this.state.apikeySecret.label;
    var thisComponent = this;
    $.ajax(
      {
        url: "/api/languages",
        async: false,
        method: 'GET',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token")

        },
        success: function (res) {
          thisComponent.state.showLoader = false;
          if (res.success === true) {
            for (var i = 0; i < res.result.length; i++) {

              thisComponent.state.langList.push({ "value": res.result[i]["name"], "label": res.result[i]["code"] });
            }
            thisComponent.state.langDispValue = { "value": res.result[0]["name"], "label": res.result[0]["code"] };
            thisComponent.setState(thisComponent.state);
          }
        },
        error: function (xhr, status, error) {
          var errorMessage = xhr.status + ': ' + xhr.statusText
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    );

  }

  fetchConvertedTextApi = () => {
    var username = this.state.apikeySecret.value;
    var password = this.state.apikeySecret.label;
    var thisController = this;
    if (document.getElementById("text").value === "") {
      thisController.notifyNoInput();
    } else if (thisController.state.langDispValue === null) {
      thisController.notifyNoIndicLangSelected();
    } else {

      var text = document.getElementById("text").value;
      var infoType = document.getElementById("infoType").innerText;
      var lang = document.getElementById("language").innerText;
      var data = {
        'projectId': localStorage.getItem("currentProjectId"),
        'text': text,
        'targetLanguage': lang,
        'entityType': infoType
      }

      $.ajax({
        url: "/api/transcribe-api",
        async: false,
        method: 'POST',
        headers: {

          "Authorization": "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",

        },
        data: {
          projectId: localStorage.getItem('currentProjectId'),
          text: text,
          targetLanguage: lang,
          entityType: infoType
        },

        success: function (res) {
          if (res.success === true) {
            document.getElementById("convertedText").value = res.result;
          } else if (res.success === false && res.result === '-1') {
            thisController.notifyFailedToLoadLanguages("Ooops!ArrayIndexOutOfBound Exception occured");
          } else {
            thisController.notifyFailedToLoadLanguages(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }

      }
      );
    }
  }

  reset = () => {
    document.getElementById("text").value = "";
    document.getElementById("convertedText").value = "";
  }
  componentDidMount() {
    setTimeout(() => {
      this.fetchAksharTransliterationDataApi();
      this.fetchLanguageApi();
      this.fetchInformationTypeApi();
    }, 300);

  }
  render() {
    const selectedOption = this.state.selectedLanguageOption;
    return (
      <div>

        <div >
          {/* for toaster */}
          <link rel="stylesheet" href="./assets/css/ReactToastify.css" />

          {/* for reactTable */}
          <link rel="stylesheet" href="./assets/css/React_Table_CSS/react-table.css" />

          {/*links for css files used for popup */}
          <link href="./assets/css/ej2-base.css" rel="stylesheet" />
          <link href="./assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="./assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="./assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="./assets/css/screenResolution.css" rel="stylesheet" />
          < ToastContainer className="Toast-at-center" />

          <div className="row">
            <div className="col-sm-4">
            </div></div>
          <br />
          <div className="row">
            <div className="col-sm-2" style={{ marginTop: '-20px' }}>
              <h6 className="nav-item" style={{
                color: '#282a65',
                marginLeft: '20px'
              }}>Akshar Transliteration</h6>
            </div>
          </div><br />
          <div className="row">
            <label style={{ marginTop: "13px", marginLeft: '5px' }}>Information Type:</label>
            <div className="col-sm-3">

              <Select
                style={{ width: '12px' }}
                value={this.state.infoTypeDispValue}
                onChange={this.handleInfoTypeChange}
                options={this.state.infoTypeList}
                id="infoType"
              />

            </div>

          </div>
          <div className="row">
            <label style={{ marginTop: "13px", marginLeft: '5px' }}>Target Language :</label>
            <div className="col-sm-3" >

              <Select
                style={{ width: '12px' }}
                value={this.state.langDispValue}
                onChange={this.handleLangChange}
                options={this.state.langList} id="language" />

            </div>

          </div>

        </div><div className="row" style={{ marginTop: "20px" }}>
          <div className="col-md-3">
            <label>Source Text</label>

            <div className="card" style={{ borderRadius: '10px' }}>

              <textArea style={{ height: "200px", borderRadius: '2px' }} id="text" />
            </div>

          </div>
          <div className="col-md-3" style={{ textAlign: 'center', marginTop: '36px', display: 'grid' }}>
            <button className="btn2 table-action-button "
              title="Akshar value"
              style={{
                width: '124px', height: '36px', marginLeft: 'auto', marginRight: 'auto',
                marginTop: 'auto'
              }} onClick={this.fetchConvertedTextApi}>Transliterate</button>

            <button className="btn2 table-action-button "
              title="Reset your input"
              style={{ width: '90px', height: '36px', marginLeft: 'auto', marginRight: 'auto', marginBottom: '54px' }} onClick={this.reset}>
              <img src="assets/images/reset.png" />Reset
            </button>


          </div>

          <div className="col-md-5">
            <label>Transliterated Text</label>
            <div className="card" style={{ borderRadius: '10px' }}>
              <textArea style={{ height: "200px", borderRadius: '2px' }} readOnly={true} id="convertedText" />
            </div>
          </div>
        </div>

      </div >

    );
  }
}

export default AksharTransliteration;



// WEBPACK FOOTER //
// ./src/aksharUi/AksharTransliteration.js